export default "/assets/site/images/75.png?08959234226fe0f60d4d4a197799ef3a";